// @flow
import action from 'app/common/lib/action';
import i18n from 'app/i18n';

import api from '../api';


export const STUDENT_UPDATE_REQUEST = 'childSettings/STUDENT_UPDATE_REQUEST';
export const STUDENT_UPDATE_SUCCESS = 'childSettings/STUDENT_UPDATE_SUCCESS';
export const STUDENT_UPDATE_FAILURE = 'childSettings/STUDENT_UPDATE_FAILURE';


/**
* Запрос изменения данных ребенка
 */

type Data = {
  gender: string,
}

export const studentUpdate = (studentId: number, data: Data) => async (dispatch: Function): Promise<*> => {
  dispatch(action(STUDENT_UPDATE_REQUEST, { studentId, data }));
  try {
    await api(`cabinet/students/${studentId}`, 'put', { data });
    const oldData = data.gender ? { ...data, sex: data.gender } : data;
    dispatch(action(STUDENT_UPDATE_SUCCESS, { studentId, data: oldData }));
    return true;
  } catch (error) {
    const errText = i18n.t('app:request_child_update_failed');
    dispatch(action(
      STUDENT_UPDATE_FAILURE, {
        err: errText,
        error,
      }
    ));
    return false;
  }
};
